import isObject from './isObject';

const paginatify = (value: any): { edges: any[], pageInfo: {} } => {
  if (!isObject(value)) {
    throw new TypeError('value must be an object for paginatify(value).');
  }

  if (!Array.isArray(value['edges'])) {
    throw new TypeError('value.edges must be an array for paginatify(value).');
  }

  if (!isObject(value['pageInfo'])) {
    throw new TypeError('value must be an object for paginatify(value).');
  }

  return {
    edges: (value['edges'] as any[]).map(item => ({ ...item['node'], cursor: item['cursor'] })),
    pageInfo: value['pageInfo'],
  };
};

export default paginatify;
